import { render } from "./PaymentTable.vue?vue&type=template&id=6f4b984f"
import script from "./PaymentTable.vue?vue&type=script&lang=js"
export * from "./PaymentTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__